define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"csi/heading/Renderer",
	"csi/reflection",
	"csi/xml"
], function(array,declare,Renderer,reflection,xml) {

	return declare(Renderer, {
		_getValue: function(/*csi.def.Context*/ctx, /*csi.def.Heading*/h) {
			// summary: value is breadcrumb trail
			var	parent = ctx.getParent();
			var	rcr = reflection.getRelationBetweenNodes(ctx.getNode(), parent, true);
			if (!rcr) return 0;

			var	value = xml.nodeGetAttributeValue(parent, rcr.getId());
			return value ? (array.indexOf(value, ctx.getNodeURL()) + 1) : 0;
		}
	});
});